module.exports = __webpack_public_path__ + "static/picleft-9db78985bc108a6716346c30a1212371.png";